// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"6943d5f1","453":"5565870f","455":"9a02ee44","977":"70db5f93"}[chunkId] + ".chunk.js";
};